import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import AdminLayout from '../../components/AdminLayout';
import { FaUsers, FaEnvelope, FaCalendarAlt, FaClock, FaSearch, FaDownload } from 'react-icons/fa';

function Visitors() {
  const [visitors, setVisitors] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetchVisitors();
  }, []);

  const fetchVisitors = async () => {
    setLoading(true);
    try {
      const res = await api.get('/visitor/list');
      setVisitors(res.data.visitors);
      setTotal(res.data.total);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const filtered = searchQuery
    ? visitors.filter(v =>
        v.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.email?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : visitors;

  const exportCSV = () => {
    const header = 'Name,Email,Signed Up,Last Login\n';
    const rows = visitors.map(v =>
      `"${v.name || ''}","${v.email}","${new Date(v.created_at).toLocaleDateString()}","${new Date(v.last_login).toLocaleDateString()}"`
    ).join('\n');
    const blob = new Blob([header + rows], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `visitors_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <h2><FaUsers style={{ marginRight: 8 }} /> Visitors</h2>
        <button className="btn btn-secondary" onClick={exportCSV} disabled={visitors.length === 0}>
          <FaDownload /> Export CSV
        </button>
      </div>

      {/* Stats */}
      <div className="visitors-stats">
        <div className="visitor-stat-card">
          <FaUsers className="visitor-stat-icon" style={{ color: '#6366f1' }} />
          <div>
            <div className="visitor-stat-number">{total}</div>
            <div className="visitor-stat-label">Total Visitors</div>
          </div>
        </div>
        <div className="visitor-stat-card">
          <FaEnvelope className="visitor-stat-icon" style={{ color: '#22d3ee' }} />
          <div>
            <div className="visitor-stat-number">{new Set(visitors.map(v => v.email)).size}</div>
            <div className="visitor-stat-label">Unique Emails</div>
          </div>
        </div>
        <div className="visitor-stat-card">
          <FaCalendarAlt className="visitor-stat-icon" style={{ color: '#34d399' }} />
          <div>
            <div className="visitor-stat-number">
              {visitors.filter(v => {
                const d = new Date(v.created_at);
                const now = new Date();
                return d.toDateString() === now.toDateString();
              }).length}
            </div>
            <div className="visitor-stat-label">New Today</div>
          </div>
        </div>
      </div>

      {/* Search */}
      <div className="admin-filters">
        <div className="visitor-search-wrap">
          <FaSearch className="visitor-search-icon" />
          <input
            type="text"
            placeholder="Search by name or email..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            className="form-input"
          />
        </div>
      </div>

      {loading ? (
        <div className="loading-text">Loading...</div>
      ) : filtered.length === 0 ? (
        <div className="empty-state" style={{ padding: '40px 0', textAlign: 'center', color: 'var(--text-secondary)' }}>
          {searchQuery ? 'No visitors match your search.' : 'No visitors yet. They will appear here after signing in with Google.'}
        </div>
      ) : (
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Visitor</th>
                <th>Email</th>
                <th>Signed Up</th>
                <th>Last Login</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(v => (
                <tr key={v.id}>
                  <td>
                    <div className="visitor-cell">
                      {v.avatar ? (
                        <img src={v.avatar} alt="" className="visitor-table-avatar" />
                      ) : (
                        <div className="visitor-table-avatar-placeholder">
                          {v.name ? v.name.charAt(0).toUpperCase() : '?'}
                        </div>
                      )}
                      <strong>{v.name || 'Unknown'}</strong>
                    </div>
                  </td>
                  <td><a href={`mailto:${v.email}`} className="visitor-email-link">{v.email}</a></td>
                  <td>{new Date(v.created_at).toLocaleDateString()}</td>
                  <td>
                    <span className="visitor-last-login">
                      <FaClock style={{ fontSize: '0.75rem' }} /> {new Date(v.last_login).toLocaleDateString()}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default Visitors;
